import { API_BASE_URL, AUTH_ENDPOINTS } from './config';
import { apiFetch } from './client';

/**
 * Auth API - login, logout, token refresh for DXLiving
 * JWT: Access token 60min, Refresh token 30 days
 */

const authUrl = (path) => `${API_BASE_URL}${path}`;

/**
 * POST /api/v1/auth/login
 * @param {{ email: string, password: string }} credentials
 * @returns {Promise<{ accessToken: string, refreshToken: string, tokenType: string, expiresAt: string, user: object }>}
 */
export async function login(credentials) {
  const res = await fetch(authUrl(AUTH_ENDPOINTS.login), {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(credentials),
  });

  const data = await res.json().catch(() => ({}));

  if (!res.ok) {
    const msg = data.message || data.error || `Login failed (${res.status})`;
    throw new Error(msg);
  }

  return data;
}

/**
 * POST /api/v1/auth/logout
 * Invalidates session on server. Uses Bearer token from apiFetch.
 */
export async function logout() {
  const res = await apiFetch(AUTH_ENDPOINTS.logout, { method: 'POST' });
  if (!res.ok) {
    const data = await res.json().catch(() => ({}));
    const msg = data.message || data.error || `Logout failed (${res.status})`;
    throw new Error(msg);
  }
  return res.json().catch(() => ({}));
}

/**
 * POST /api/v1/auth/token/refresh
 * @param {{ refreshToken: string }} body
 * @returns {Promise<{ accessToken: string, refreshToken: string, tokenType: string, expiresAt: string, user?: object }>}
 */
export async function refreshToken(refreshToken) {
  const res = await fetch(authUrl(AUTH_ENDPOINTS.refresh), {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ refreshToken }),
  });

  const data = await res.json().catch(() => ({}));

  if (!res.ok) {
    const msg = data.message || data.error || `Token refresh failed (${res.status})`;
    throw new Error(msg);
  }

  return data;
}
